import {
  createAction,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";
import type { INavigationItemsMenu } from "../../InterfacesTypes/interfaces";

export interface INavigationItemsMenusState {
  navItems: INavigationItemsMenu[];
  loading: boolean;
  error: string | null;
}

const initialState: INavigationItemsMenusState = {
  navItems: [],
  loading: false,
  error: null,
};
export const fetchNavigationItems = createAction(
  "navigation/fetchNavigationItems"
);

export const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    fetchStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess(state, action: PayloadAction<INavigationItemsMenu[]>) {
      state.loading = false;
      state.navItems = action.payload;
    },
    fetchFailure(state, action: PayloadAction<string | null | undefined>) {
      state.loading = false;
      state.error = action.payload ?? "Något gick fel";
    },
    // optional helper if you ever set items locally
    setNavItems(state, action: PayloadAction<INavigationItemsMenu[]>) {
      state.navItems = action.payload;
    },
  },
});

export const { fetchStart, fetchSuccess, fetchFailure, setNavItems } =
  navigationSlice.actions;

export const navigationReducer = navigationSlice.reducer;
